export const IFRAME_ID = 'IFRAME_ID'
export const DEFAULT_ISLOGGEDIN_STATE = false
export const ISLOGGEDIN_IFRAME_MESSAGE_TYPE = 'ISLOGGEDIN_IFRAME_MESSAGE_TYPE'
export const IS_LOGGEDIN_IFRAME_LOAD_TIMEOUT = 3500

export const API_NOT_LOGGED_PARAMETER = 'error'
export const API_LOGGED_PARAMETER = 'access_token'

export const API_REDIRECT_URL_PATHNAME = '/authentication'
